import { TuiIconTdsServiceChevronLeft, TuiIconTdsServiceChevronRight } from '@tui-react/proprietary-icons';
import cn from 'classnames';
import React, { useEffect } from 'react';
import styles from './GalleryNavigationToolbar.module.css';

interface GalleryNavigationToolbarProps {
  className?: string;
  imageLabel: string;
  currentIndex: number;
  total: number;
  onChangeIndex: (index: number) => void;
}

export const GalleryNavigationToolbar: React.FC<GalleryNavigationToolbarProps> = ({
  className,
  currentIndex,
  total,
  onChangeIndex,
}) => {
  const isNextDisabled = currentIndex === total - 1;
  const isPreviousDisabled = currentIndex === 0;

  const handleSelectNext = () => {
    onChangeIndex(currentIndex + 1);
  };

  const handleSelectPrevious = () => {
    onChangeIndex(currentIndex - 1);
  };

  useEffect(() => {
    const handleKeyPress = ({ key }: KeyboardEvent) => {
      if ((key === 'ArrowLeft' || key === 'ArrowDown') && !isPreviousDisabled) {
        handleSelectPrevious();
      }

      if ((key === 'ArrowRight' || key === 'ArrowUp') && !isNextDisabled) {
        handleSelectNext();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [currentIndex]);

  return (
    <div className={cn(styles.container, className)}>
      <button className={styles.iconButton} onClick={handleSelectPrevious} disabled={isPreviousDisabled}>
        <TuiIconTdsServiceChevronLeft iconSize="var(--icon-xs)" />
      </button>

      <span className={styles.index}>{`${currentIndex + 1} / ${total}`}</span>

      <button className={styles.iconButton} onClick={handleSelectNext} disabled={isNextDisabled}>
        <TuiIconTdsServiceChevronRight iconSize="var(--icon-xs)" />
      </button>
    </div>
  );
};
